import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import TableTransactionDetails from '../../material-kit/tables/credioTransactionTable';
import { useParams } from 'react-router-dom';

const TransactionTab = () => {

    const [selectedTab, setSelectedTab] = useState();

    let { type } = useParams();

    useEffect(() => {
        if (type) setSelectedTab(type);
    }, [
        type
    ])

    const handleChange = (_, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="transaction tabs"
                sx={{ mb: 2, mx: 4, mt: 4 }}
            >
                <Tab value="withdrawals" label="Withdrawals" />
                <Tab value="deposit" label="Deposit" />
                <Tab value="reader" label="Reader" />
                <Tab value="coralpay" label="Coral Pay" />
                <Tab value="shm" label="SHM VAS" />
                <Tab value="card" label="Card Transactions" />
                <Tab value="saving" label="Savings" />
                <Tab value="reversals" label="Reversals" />
            </Tabs>

            <TableTransactionDetails type={selectedTab} />
        </Box>
    );
};

export default TransactionTab;
